import { gql } from '@apollo/client';

export const RELEASE_COMMANDO_MUTATION = gql`
  mutation ReleaseCommando($id: Int!) {
    mcp {
      releaseCommando(id: $id) {
        success
        message {
          code
          message
        }
        content {
          id
          cd
          status
        }
      }
    }
  }
`;
